import React, { useState } from "react";
import FormWrapper from "../../components/Common/FormWrapper";
import showToast from "../../utils/toastNotifications";

const ReqMaintaince = () => {
  const [selectedTenant, setSelectedTenant] = useState("");
  const [description, setDescription] = useState("");
  const [dropdownError, setDropdownError] = useState("");
  const [textareaError, setTextareaError] = useState("");

  const handleLegalSubmit = () => {
    let hasError = false;

    if (!selectedTenant) {
      setDropdownError("Please select a unit or tenant");
      showToast("error", "Please select a unit or tenant");
      hasError = true;
    } else {
      setDropdownError("");
    }

    if (!description.trim()) {
      setTextareaError("This field is required.");
      showToast("error", "Please enter a description");
      hasError = true;
    } else {
      setTextareaError("");
    }

    if (hasError) return;

    showToast("success", "Request submitted successfully!");
  };

  return (
    <div className="bg-diagonal-sky w-full min-h-screen">
      <div className="p-4 sm:p-[20px] md:p-[24px] lg:p-[30px] flex justify-center">
        <div className="w-full">
          <FormWrapper
            wrapperHeight="h-[604px] sm:h-[620px] md:h-[630px] lg::h-[638px]"
            dropdownLabel="Select Unit or Tenant"
            dropdownPlaceholder="All units and active tenants"
            dropdownOptions={[
              { value: "1", label: "John Smith (Tenant - Unit 1A)" },
              { value: "2", label: "Daniel Lee (Unit 4D)" },
              { value: "3", label: "Sarah Lewis (Unit 2B)" },
              { value: "4", label: "Aisha Malik (Tenant - Unit 1C)" },
            ]}
            dropdownValue={selectedTenant}
            onDropdownChange={(selected) => setSelectedTenant(selected)}
            dropdownError={dropdownError}
            textareaLabel="Reason / Description"
            textareaPlaceholder="Briefly describe the issue (e.g., plumbing leak, broken light)"
            textareaValue={description}
            onTextareaChange={(e) => setDescription(e.target.value)}
            textareaError={textareaError}
            buttonLabel="Submit"
            onSubmit={handleLegalSubmit}
            required
          />
        </div>
      </div>
    </div>
  );
};

export default ReqMaintaince;

